var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":_vm.iframesrc,"height":"700px","width":"100%","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }